import { cn } from '@cyphex/ui';
import type { CustomEmoji } from '@cyphex/types/admin';
import { emojiSrc } from '../api/emojiApi';

export interface CustomEmojiButtonProps {
  emoji: CustomEmoji;
  onSelect: (token: string) => void;
  className?: string;
}

/**
 * One tile in the picker's custom section.
 *
 * The value handed back is the `:name:` TOKEN, not the URL — that token is what
 * the message body and the reaction column both store, so the picker and the
 * renderer can never disagree about what was chosen.
 */
export function CustomEmojiButton({ emoji, onSelect, className }: CustomEmojiButtonProps) {
  const token = `:${emoji.name}:`;
  return (
    <button
      type="button"
      onClick={() => onSelect(token)}
      title={token}
      aria-label={`React with ${token}`}
      className={cn(
        'flex h-8 w-8 items-center justify-center rounded-md transition-colors duration-fast',
        'hover:bg-subtle focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        className,
      )}
    >
      <img
        src={emojiSrc(emoji.url)}
        alt={token}
        className="h-5 w-5 object-contain"
        loading="lazy"
        decoding="async"
      />
    </button>
  );
}
